import { Component, OnInit, AfterViewInit, OnDestroy} from '@angular/core';
import { PlantServiceService } from '../../../../services/dashboard/solar/plant-service.service';
import { ActivatedRoute } from '@angular/router';
import { SolarConfigModel } from '../../../../models/solar-configuration.model';
import { Subscription, combineLatest, Subject } from 'rxjs';
@Component({
  selector: 'app-plant-overview',
  templateUrl: './plant-overview.component.html',
  styleUrls: ['./plant-overview.component.scss']
})
export class PlantOverviewComponent implements OnInit, AfterViewInit, OnDestroy  {
  siteId: string;
  solarConfig: SolarConfigModel;
  //
  latestIrradiance: any;
  totalACPower: any;
  totalDCPower: any;
  planStatusInterval = 30;
  //
  resizeSubject: Subject<any> = new Subject();
  constructor(private activeRoute: ActivatedRoute,
    private plantService: PlantServiceService) {
    this.solarConfig = new SolarConfigModel();
    // this.siteId = this.activeRoute.snapshot.queryParams['siteId'];
  }

  ngOnInit() {
  // Combine them both into a single observable
  const urlParams = combineLatest(
    this.activeRoute.params,
    this.activeRoute.queryParams,
    (params, queryParams) => ({ ...params, ...queryParams})
  );

  // Subscribe to the single observable, giving us both
  urlParams.subscribe(routeParams => {
    // routeParams containing both the query and route params
      // this.loadUserDetail(routeParams.id, routeParams.type);
      this.siteId = routeParams.siteId;
      this.plantService.getSolarConfigurationInfo(this.siteId)
      .subscribe(res => {
        this.solarConfig = <SolarConfigModel>res;
        this.solarConfig.siteId = this.siteId;
        this.plantService.sendSolarConfigSubject(this.solarConfig);
      });
  });
}
ngAfterViewInit() {
  const seft = this;
  window.onresize = function () {
    seft.resizeSubject.next(this);
  };
}
ngOnDestroy() {
  // console.log('OnDestroy subscription');
  //  this.subscription.unsubscribe();
  // this.plantService.clearSolarConfigSubject();
  this.plantService.unSubscribeSolarConfigSubject();
}
}
